import { forwardRef, type ReactNode } from "react";

import classNames from "classnames";

import { useLoyaltyProductPoints } from "@checkout/hooks/useLoyaltyProductPoints";
import { useLoyaltyStatus } from "@checkout/hooks/useLoyaltyStatus";

import { CartMiniItems, type CartMiniItemsProps } from "../../components/CartMiniItems";
import { CartMiniPointsBlock } from "../../components/CartMiniPointsBlock";

import styles from "./CartMiniContent.module.scss";

interface CartMiniContentType extends CartMiniItemsProps {
  buyLimitation: boolean;
  freeShippingProgressBar?: ReactNode;
  onScroll?: () => void;
}

export const CartMiniContent = forwardRef<HTMLDivElement, CartMiniContentType>(function CartMiniContent(
  {
    pending,
    items,
    qtyPending,
    buyLimitation,
    freeShippingProgressBar,
    onRemoveItemClick,
    onItemQuantityChange,
    onRemoveItems,
    onScroll,
  },
  ref
) {
  const hasLoyalty = useLoyaltyStatus();
  const totalLoyaltyPoints = useLoyaltyProductPoints(items);

  const contentClasses = classNames(styles.contentContainer, {
    [styles.empty]: !(items?.length > 0),
    [styles.pending]: pending,
  });

  return (
    <div className={contentClasses} ref={ref} onScroll={onScroll} data-testid="miniCartScrollableContent">
      {freeShippingProgressBar}
      <CartMiniItems
        pending={pending}
        items={items}
        qtyPending={qtyPending}
        buyLimitation={buyLimitation}
        onRemoveItemClick={onRemoveItemClick}
        onItemQuantityChange={onItemQuantityChange}
        onRemoveItems={onRemoveItems}
      />
      <CartMiniPointsBlock totalPoints={totalLoyaltyPoints} pending={pending} isActive={hasLoyalty} />
    </div>
  );
});
